import PropTypes from 'prop-types'

export default PropTypes.shape({
  portLocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  portName: PropTypes.string.isRequired,
})
